import API from "../http-common";

import { debugLog } from "../utils/debugUtils";

const getAll = () => {
	return API.get("/scenarios");
};

const get = (id) => {
	return API.get(`/scenarios/${id}`);
};

const dump = (id) => {
	return API.get(`/scenarios/dump/${id}`);
};

const create = (data) => {
	return API.post("/scenarios", data);
};

const update = (id, data) => {
	return API.put(`/scenarios/${id}`, data);
};

const importScenario = (data) => {
	return API.post(`/scenarios/import`, data);
};

const copy = (data) => {
	return API.post("/scenarios/copy", data);
};

const remove = (data) => {
	// return API.delete(`/scenarios/${id}`);
	return API.post("/scenarios/delete", data);
};

const findByUuid = (uuid) => {
	return API.get(`/scenarios/uuid/${uuid}`);
};

const updateScenarioStatus = (id, status_id, updatedBy) => {
	return API.put(`/scenarios/${id}/status`, { status_id, updatedBy });
};

const ScenarioService = {
	getAll,
	get,
	dump,
	create,
	update,
	copy,
	remove,
	importScenario,
	findByUuid,
	updateScenarioStatus
};

export default ScenarioService;
